import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {NoItemProps} from './NoItemProps.interface';

export function NoItem({isMobile, children}: NoItemProps) {
  return (
    <div
      className={twMerge(
        'flex-center-full',
        isMobile ? 'min-h-200pxr' : 'min-h-364pxr'
      )}
    >
      <Text className="font-medium2 whitespace-pre-wrap text-center text-theme-solid-100">
        {children}
      </Text>
    </div>
  );
}
